import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLabels } from 'wsm-common-data';
import { useHistory } from '../hooks/useHistory';
import { FetchReviewsContext } from '../providers/FetchReviewsProvider';
import Review from './Review';
import ReviewLoader from './ReviewLoader';
import Filters from './Filters';
import Disclaimer from './Disclaimer';
import SubHeading from './SubHeading';
import PageNavigation from './PageNavigation';
import Alert from './Alert';

const ReviewContent = () => {
	const reviews = useSelector((state) => state.reviews);
	const labels = useLabels();
	const { isLoading } = useContext(FetchReviewsContext);
	useHistory();

	return (
		<div className="review-content">
			<SubHeading />
			<Disclaimer>{labels.get('VW_REVIEWS_DISCLAIMER')}</Disclaimer>
			<Filters />
			{reviews.length > 0 && (
				<section>
					<ul className="reviews list-unstyled border-top border-bottom pt-4">
						{reviews.map((review) => {
							return isLoading ? (
								<ReviewLoader
									className="fade-in"
									key={review.commentId}
								/>
							) : (
								<Review
									key={review.commentId}
									review={review}
									className="fade-in"
								/>
							);
						})}
					</ul>
					<PageNavigation />
				</section>
			)}
			{reviews.length === 0 && (
				<Alert type="info">{labels.get('NO_RESULTS_FOUND')}</Alert>
			)}
		</div>
	);
};

export default ReviewContent;
